const topics = [
  { tag: '探花大神合集', count: '12.8k', hot: true, trend: 'up' },
  { tag: '探花一区精选', count: '9.6k', hot: true, trend: 'up' },
  { tag: '探花91社区', count: '8.3k', hot: true, trend: 'up' },
  { tag: '九一探花', count: '7.1k', hot: false, trend: 'stable' },
  { tag: '极品探花', count: '6.5k', hot: true, trend: 'up' },
  { tag: '探花精选资源', count: '5.9k', hot: false, trend: 'stable' },
  { tag: '探花探花推荐', count: '5.2k', hot: false, trend: 'up' },
  { tag: '探花精品合集', count: '4.8k', hot: false, trend: 'stable' },
  { tag: '探花新品速递', count: '4.3k', hot: true, trend: 'up' },
  { tag: '探花大神作品', count: '3.9k', hot: false, trend: 'stable' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-hashtag"></i>
              热门标签
            </div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
              话题热度榜
            </h2>
          </div>
          <p className="text-xs text-foreground-500">数据实时更新 · 反映社区关注热度</p>
        </div>

        <div className="flex flex-wrap gap-2 md:gap-3">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#index"
              onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 ${
                item.hot
                  ? 'bg-accent-50 border-accent-200 hover:bg-accent-100 hover:border-accent-300'
                  : 'bg-background-50 border-background-200/70 hover:bg-background-100 hover:border-background-300'
              }`}
            >
              <span className={`text-sm font-medium whitespace-nowrap ${item.hot ? 'text-accent-700' : 'text-foreground-700'}`}>
                #{item.tag}
              </span>
              <span className={`text-[11px] font-medium ${item.hot ? 'text-accent-500' : 'text-foreground-400'}`}>
                {item.count}
              </span>
              {item.trend === 'up' && (
                <i className={`ri-arrow-up-line text-xs ${item.hot ? 'text-accent-500' : 'text-foreground-400'}`}></i>
              )}
              {item.hot && (
                <span className="inline-flex w-1.5 h-1.5 rounded-full bg-accent-500 animate-pulse"></span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}